/**
 * @desc 入库
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockOrderInboundCmd, options?: any) {
  return updateResponse(
    http(URL + `/stock/inbound`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
